<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="companyName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="companyName"></wbo-main-search-column>
        <wbo-column field="ABN"></wbo-column>
        <wbo-column field="gstNumber"></wbo-column>
        <wbo-column field="city"></wbo-column>
        <wbo-column field="state"></wbo-column>
        <wbo-checkbox-column field="defaultCompany"></wbo-checkbox-column>
        <wbo-actions-search-column>
            <wbo-company-delete-search-action></wbo-company-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>

